import type {
  AppointmentRequest,
  AppointmentRequestWithoutRegistration,
} from "src/core/backend/clients/backendClient";
import { backendService } from "../../../core/backend/services/backendService";

class AppointmentService {
  public appointmentList() {
    return backendService.createBackendClient().apiAppointmentList();
  }

  public appointmentPost(request: AppointmentRequest) {
    return backendService.createBackendClient().apiAppointmentPost(request);
  }

  public appointmentCreateWithoutRegistration(
    request: AppointmentRequestWithoutRegistration
  ) {
    return backendService
      .createBackendClient()
      .apiAppointmentCreateWithoutRegistration(request);
  }

  public appointmentDelete(id: number) {
    return backendService.createBackendClient().apiAppointmentDelete(id);
  }

  public appointmentConfirm(id: number, key: string) {
    return backendService.createBackendClient().apiAppointmentConfirm(id, key);
  }

  public appointmentTerminate(id: number, key: string) {
    return backendService
      .createBackendClient()
      .apiAppointmentTerminate(id, key);
  }
}

export const appointmentService = new AppointmentService();
